import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import ReactDatetime from "react-datetime";
import { capitalizeFirstLetter } from '../Shared/Helpers';
import moment from 'moment';
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepNine = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (storedData) {
            setFormData(storedData?.savingScheme);
        } else {
            console.log("storedData is empty");
        }
    }, []);


    const validateForm = (formData) => {
        const errors = {
            name: isEmpty(formData?.name) && 'Name is required',
            nino: isEmpty(formData?.nino) && 'Nino is required',
            address: isEmpty(formData?.address) && 'Address is required',
            depot: isEmpty(formData?.depot) && 'Depot is required',
            amount: isEmpty(formData?.amount.toString()) && 'Amount is required',
            joinedDate: isEmpty(formData?.joinedDate) && 'Date of joining is required',
            checkRules: formData?.checkRules === false ? 'Understand the rules is required' : false,
        };
        return errors;
    }

    const handleSkip = () => {
        handleNext({ savingScheme: null });
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);

            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const url = `/HRInduction/SubmitEmployeeSavingsScheme?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}&chosenEmployeeScheme=${true}`;
                const method = `post`;
                const data = {
                    ...formData,
                    amount: Number(formData.amount)
                }
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                    body: JSON.stringify(data),
                });
                if (response.status === 200) {
                    handleNext({ savingScheme: data });
                } else {
                    showErrorAlert(`Please fill out all required fields`);
                }
            } else {
                showErrorAlert(`Please fill out all required fields`);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            showErrorAlert(`Something went wrong`);
        }
    }

    const handleCheck = (e) => {
        setFormData({
            ...formData,
            checkRules: !formData?.checkRules
        })
    }

    const handleDateChange = (date) => {
        setFormData({ ...formData, joinedDate: date.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") });
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    return (
        <Row>
            {alert}
            <Col sm={12} md={12}>
                <h2 >9. Employee Savings Scheme</h2>
                <span style={{ marginTop: '-15px' }}><h2 >FP McCann - Employee Savings Scheme</h2></span>
                <span style={{ marginTop: '-15px' }}>Please fill out all required fields</span>
            </Col>

            <Col sm={12} md={12}>
                <span><h5><strong><u>Rules:</u></strong></h5></span>
                <div className='d-flex justify-content-start'>
                    <ul >
                        <li><h5>The Scheme is available to direct employees upon commencement of employment</h5></li>
                        <li><h5>If you choose to join later, the joining dates will be 1st February & 1st August</h5></li>
                        <li><h5>Choose the amount that you wish to save (This will remain for the 6 month period, at which point you can choose to change the amount).</h5></li>
                        <li><h5>The value of your savings pot will be paid to you during the first week in June & December each year</h5></li>
                        <li><h5>If you choose to leave the scheme, please do so by providing a letter to the payroll department. We will aim to pay your savings within 2 weeks of your intention to leave. You will not be able to re-join the scheme until the following 1st February or 1st August.</h5></li>
                        <li><h5>On termination of employment, savings will be included in your final wages / salary.</h5></li>
                    </ul>
                </div>
            </Col >

            <Col sm={12} md={12}>
                <span><h5 className='text-capitalize'><strong>What do I have to do now?</strong></h5></span>
                <span><h5 className="">All you have to do now is complete the form and return to the payroll department.</h5></span>
            </Col>

            <Col sm={6} className="my-1">
                <h5 className="">Name:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData?.name}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                name: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.name ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.name && <Form.Text className="text-danger"> <span className="star">*</span> {errors.name} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={6} className="my-1">
                <h5 className="">NINO:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData?.nino}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                nino: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.nino ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.nino && <Form.Text className="text-danger"> <span className="star">*</span> {errors.nino} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={6} className="my-1">
                <h5 className="">Address:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData?.address}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                address: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.address ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.address && <Form.Text className="text-danger"> <span className="star">*</span> {errors.address} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={6} className="my-1">
                <h5 className="">Depot/Department:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData?.depot}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                depot: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.depot ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.depot && <Form.Text className="text-danger"> <span className="star">*</span> {errors.depot} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={6} className="my-1">
                <h5 className="">Amount:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData?.amount}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                amount: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.amount ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.amount && <Form.Text className="text-danger"> <span className="star">*</span> {errors.amount} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={6} md={6} className="my-1">
                <h5>Date of joining:<span className="star">*</span></h5>
                <Form.Group>
                    <ReactDatetime
                        inputProps={{
                            className: errors.joinedDate ? "form-control is-invalid custom-input" : "form-control custom-input",
                            name: "contact",
                            disabled: false,
                            onKeyDown: (e) => { e.preventDefault() }
                        }} defaultValue={new Date()}
                        value={moment(formData?.joinedDate)}
                        onChange={handleDateChange}
                        timeFormat={false}
                        dateFormat="DD/MM/YYYY"
                    />
                </Form.Group>
                {errors.joinedDate && <Form.Text className="text-danger"> <span className="star">*</span> {errors.joinedDate} </Form.Text>}
            </Col>

            <Col sm={12} md={12}>
                <Form.Group className='d-flex'>
                    <Form.Check.Label style={{ textAlign: 'left' }}>
                        <Form.Check.Input
                            type="checkbox"
                            checked={formData?.checkRules === true}
                            onChange={handleCheck}
                        ></Form.Check.Input>
                        <span className="form-check-sign" style={{ paddingRight: "10px" }}></span>
                        <><span>I understand the rules of the Employee Savings Scheme and confirm that I wish to join. I agree to the deduction being made from my payroll on a regular basis.</span><span className="star">*</span>
                        </>
                    </Form.Check.Label>
                </Form.Group>
                {errors.checkRules && <Form.Text className="text-danger d-flex"> <span className="star">*</span> {errors.checkRules} </Form.Text>}
            </Col>

            <Col sm={12} className="d-flex justify-content-between mt-3">
                <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                <span>
                    <Button className="btn btn-lg btn-shadow btn-step" variant="success" onClick={handleSkip} >Skip</Button>
                    <Button className="btn btn-success btn-lg btn-step " variant="success" onClick={handleSubmit} >Submit</Button>
                </span>
            </Col>
        </Row >


    );
};

export default StepNine;

